import { lazy } from 'react';

const lazyLoad = (importFunction: () => Promise<any>) =>
    lazy(async () =>
        importFunction().catch((e) => {
            console.warn(e);
            return {
                default: () => null,
            };
        }),
    );

export default lazyLoad;
